import React, { useState, useEffect } from "react";

const BlueButton = ({
  onClick,
  icon: Icon,
  text = "Donate",
  className = "",
  isActive = false,
  progress = 0,
}) => {
  const [showProgressBar, setShowProgressBar] = useState(false);

  useEffect(() => {
    let timer;

    if (isActive) {
      // Delay showing progress bar
      timer = setTimeout(() => {
        setShowProgressBar(true);
      }, 500); // Longer delay to ensure transition is complete
    } else {
      // Hide immediately when inactive
      setShowProgressBar(false);
    }

    // Cleanup
    return () => {
      clearTimeout(timer);
    };
  }, [isActive]);

  return (
    <div className="relative">
      <button
        type="button"
        onClick={onClick}
        className={`
          group
          flex items-center gap-2 
          border-2 border-blue rounded-xl 
          ${isActive ? "bg-blue text-white" : "bg-white"} 
          px-2 py-2 sm:px-3 sm:py-3 md:px-4 md:py-4
          w-[140px] h-[55px] sm:w-[180px] sm:h-[70px] md:w-[210px] md:h-[80px] lg:w-[245px] lg:h-[95px]
          hover:bg-blue hover:text-white 
          transition-all duration-500 ease-in-out
          shadow-xl
          ${isActive ? "xl:scale-125 scale-110 z-10" : ""}
          ${className}
        `}
      >
        <span
          className={`flex items-center justify-center rounded-full p-1 sm:p-2 md:p-3 transition-colors duration-500 ease-in-out ${
            isActive
              ? "bg-white text-blue"
              : "bg-blue text-white group-hover:bg-white group-hover:text-blue"
          }`}
        >
          {Icon && (
            <Icon
              size={24}
              className="w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6 lg:w-7 lg:h-7"
            />
          )}
        </span>
        <span
          className={`text-xs sm:text-sm md:text-base lg:text-xl ml-1 sm:ml-2 md:ml-4 transition-colors duration-500 ease-in-out ${
            isActive ? "text-white" : "text-black group-hover:text-white"
          }`}
        >
          {text}
        </span>
      </button>
      {isActive && showProgressBar && progress > 0 && (
        <div className="absolute sm:bottom-[-4px] bottom-[0px] left-0 w-full h-1 bg-blue rounded-full overflow-hidden">
          <div
            className="h-full bg-white"
            style={{
              width: `${progress}%`,
              transition: "width 300ms linear",
            }}
          />
        </div>
      )}
    </div>
  );
};

export default BlueButton;
